// src/components/HomeTeamStrip.jsx
import React from "react";
import { Link } from "react-router-dom";

const AGENTS = [
  {
    slug: "yuliya-tkachuk",
    name: "Yuliya Tkachuk",
    title: "Broker / Owner",
    photo: "/assets/agents/broker.png",
  },
  {
    slug: "oleg-tkachuk",
    name: "Oleg Tkachuk",
    title: "CEO & Realtor",
    photo: "/assets/agents/oleg.png",
  },
  {
    slug: "agent-3",
    name: "Angelina Pitsul",
    title: "Buyer & Listing Expert",
    photo: "/assets/agents/angelina.png",
  },
  ];

export default function HomeTeamStrip() {
  return (
    <section className="home-team">
      <div className="home-team-inner">
        <h2 className="home-team-heading">Meet your Platinum Palm Properties team</h2>

        <div className="home-team-grid">
          {AGENTS.map((agent) => (
            <Link key={agent.slug} to="/agents" className="home-team-card">
              <div className="home-team-image-wrap">
                <img
                  src={agent.photo}
                  alt={agent.name}
                  className="home-team-image"
                />
              </div>

              <div className="home-team-text">
                <div className="home-team-name">{agent.name}</div>
                <div className="home-team-title">{agent.title}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
